import React from 'react';
import { Link } from 'react-router-dom';

import s from './Page404.module.scss';

const Page404 = () => (
  <div className={s.Page404}>
    <h2 className={s.Title}>
      404
      <br />
      Такой страницы не существует.
    </h2>
    <Link className={s.Link} to="/">На главную</Link>
  </div>
);

export default Page404;
